export default "__VITE_ASSET__3c30a8a9__"